module.exports = __webpack_public_path__ + "static/media/stay-home.65aa5c34.webp";